import type { NodeFormDto } from '@flow-studio/api';
import type { LabeledMenuItem } from '@flow-studio/atlas-forms-bridge';

/**
 * Adapts flow-studio's NodeFormDto[] into the generic LabeledMenuItem[] shape
 * the (app-agnostic) form-label-menu tree builder expects.
 *
 * This mapping is the only place that knows about NodeFormDto — kept out of
 * @flow-studio/atlas-forms-bridge so that package stays free of app-specific
 * types and can be relocated to a shared atlas package without change.
 */
export function mapNodeFormsToMenuItems(
  forms: NodeFormDto[],
  getDisplayTitle: (form: NodeFormDto) => string
): LabeledMenuItem<NodeFormDto>[] {
  console.log(
    '[FormLabelMenu] mapNodeFormsToMenuItems: input forms',
    forms.map((f) => ({ formID: f.formID, title: f.title, metadata: f.metadata }))
  );
  return forms.map((form) => ({
    id: form.formID,
    title: getDisplayTitle(form),
    metadataRaw: form.metadata,
    sourceDisplayOrder: form.displayOrder,
    source: form,
  }));
}
